<ion-content class="garment-listing">
  <app-header [isParentPage]="false" [title]="'Customer Site Reports'"></app-header>

  <div class="loading-container" style="padding-top:15%;" *ngIf="!loading">
    <ion-spinner></ion-spinner>
  </div>

  <ion-grid *ngIf="groupedReports | keyvalue as grouped">
    <div class="product-table">
      <table class="custom-table" *ngFor="let group of grouped">
        <thead>
          <tr>
            <th colspan="3">{{ group.key }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let report of group.value">
            <td style="width:30px">
              <a (click)="viewCustomerReports(report)" class="link">View</a>
            </td>
            <td style="width:40%">{{ report.shortName }}</td>
            <td style="width:50%">{{ report.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ion-grid>
   <ion-grid>
      <ion-row class="no-work-orders" *ngIf="(customerSiteReports?.length <= 0)">
        <ion-col>
            No Data Found
        </ion-col>
      </ion-row>
  </ion-grid>
</ion-content>
